import {
  Grid,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  Paper,
  TableBody,
} from '@mui/material';

import {
  TableRow as StyledTableRow,
  TableCell as StyledTableCell,
} from '../../../../components/common/Table';
import Button from '../../../../components/common/Button';
import { downloadCSVFile, cropsStructureTableToCSV } from '../../CSVFunctions';

export default function CropsStructureTable(props) {
  const getCSV = () =>
    downloadCSVFile(cropsStructureTableToCSV(props.groupedRows));
  return (
    <>
      <Grid item xs={12} ref={props.cropsStructureTableRef}>
        <TableContainer component={Paper}>
          <Table sx={{ minWidth: 700 }} aria-label="customized table">
            <TableHead>
              <TableRow>
                <StyledTableCell>Nazwa</StyledTableCell>
                <StyledTableCell align="center">
                  Powierzchnia (ha)
                </StyledTableCell>
                <StyledTableCell align="center">% Powierzchni</StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {props.groupedRows
                .sort((a, b) => a.id - b.id)
                .map((row) => (
                  <StyledTableRow key={row.id}>
                    <StyledTableCell component="th" scope="row">
                      {row.name}
                    </StyledTableCell>
                    <StyledTableCell align="center">{row.area}</StyledTableCell>
                    <StyledTableCell align="center">
                      {row.fieldPercent}
                    </StyledTableCell>
                  </StyledTableRow>
                ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Grid>
      <Grid
        item
        xs={10}
        container
        justifyContent="center"
        alignContent="center"
      >
        <Grid item xs={7} sx={{ my: 4, minWidth: 230 }}>
          <TableContainer>
            <Table sx={{ width: '100%' }} aria-label="customized table">
              <TableHead>
                <TableRow
                  style={{ boxShadow: '0px 1px 18px rgba(0, 0, 0, 0.12)' }}
                >
                  <StyledTableCell
                    variant="head"
                    style={{
                      borderRadius: '6px 0px 0px 6px',
                      width: '50%',
                    }}
                  >
                    Suma powierzchni (ha)
                  </StyledTableCell>
                  <StyledTableCell
                    style={{
                      borderRadius: '0px 6px 6px 0px',
                      width: '50%',
                      backgroundColor: 'rgba(0, 0, 0, 0.04)',
                      color: '#000000',
                    }}
                  >
                    {props.fieldsArea}
                  </StyledTableCell>
                </TableRow>
              </TableHead>
            </Table>
          </TableContainer>
        </Grid>
      </Grid>
      <Grid item xs={5} sx={{ mb: 6 }}>
        <Button type="submit" variant="contained" fullWidth onClick={getCSV}>
          Eksportuj do CSV
        </Button>
      </Grid>
    </>
  );
}
